import { FillInTheBlankFormFields } from '@/components/question/forms/fill-in-the-blank/FillInTheBlankForm';
import {
  fillInTheBlankOptionGenerator,
  fillInTheBlankQuestionGenerator,
} from '@/data/generators/fillInTheBlankQuestionGenerator';
import {
  FillInTheBlankOption,
  FillInTheBlankOptionCreateDTO,
} from '@/models/Answer';
import { FillInTheBlankQuestion } from '@/models/Question';
import {
  MediaUrlResolver,
  resolveStringMedia,
} from '@/utils/questions/adapterQuizForm';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export default function adapterFillInTheBlankForm(
  fillInTheBlank: FillInTheBlankFormFields,
  resolveMediaUrl: MediaUrlResolver = resolveStringMedia,
): FillInTheBlankQuestion {
  return fillInTheBlankQuestionGenerator({
    title: normalizeTranslatableField(fillInTheBlank.title),
    context: normalizeTranslatableField(fillInTheBlank.context),
    question: fillInTheBlank.question ?? '',
    options: adapterOptions(fillInTheBlank.options ?? [], resolveMediaUrl),
  });
}

const adapterOptions = (
  options: FillInTheBlankOptionCreateDTO[],
  resolveMediaUrl: MediaUrlResolver,
): FillInTheBlankOption[] =>
  options.map(({ mediaFile, ...option }, index) =>
    fillInTheBlankOptionGenerator({
      ...option,
      id: option.id ?? index,
      mediaFile: null,
      mediaLink: resolveMediaUrl(mediaFile) ?? option.mediaLink,
    }),
  );
